import { useTranslation } from "react-i18next";
import { FadeUp, Overline } from "@/components/FadeUp";
import EnquiryForm from "@/components/EnquiryForm";
import { ASSETS } from "@/lib/api";

export default function TestDrive() {
  const { t } = useTranslation();
  return (
    <div data-testid="testdrive-page">
      <section className="relative">
        <img src={ASSETS.alps} alt="Schweizer Alpenstrasse"
             className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A2540]/85" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20 md:py-28">
          <Overline><span className="text-sky-300">{t("testDrivePage.overline")}</span></Overline>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-white max-w-2xl">
            {t("testDrivePage.title")}
          </h1>
          <p className="mt-5 text-base md:text-lg text-slate-200 max-w-xl leading-relaxed">
            {t("testDrivePage.subtitle")}
          </p>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <FadeUp>
            <div className="border border-slate-200 bg-white p-8 md:p-12">
              <EnquiryForm type="probefahrt" />
            </div>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}
